export enum InternalCommunicationMessageType {
  General = 1,
  Priority
}